/**
 * Created by mykurisu on 2017/8/14.
 */
import React from 'react'
import axios from 'axios'
import {connect} from 'react-redux'
import ManageHeaderImage from '../../images/manage-header-q.png'
import ManageSpeaker from '../../images/manage-speaker.png'
import ManageBG from '../../images/liveroomSetting/liveroom-manage-bg.png'

class ManageHeader extends React.Component {

    constructor() {
        super();
        this.handleTips = this.handleTips.bind(this);
        this.handleSelfManage = this.handleSelfManage.bind(this);
        this.state = {
            isConsulter: false
        }
    }

    componentDidMount() {
        const {liveroomManage, account} = this.props;
        let consulterId = liveroomManage.consulter.id;
        if (account.id === consulterId){
           this.setState({
               isConsulter: true
           })
        }else {
            this.setState({
                isConsulter: false
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        const {liveroomManage, account} = nextProps;
        let consulterId = liveroomManage.consulter.id;
        if (account.id === consulterId){
            this.setState({
                isConsulter: true
            })
        }else {
            this.setState({
                isConsulter: false
            })
        }
    }

    handleTips() {
        let text = () => {
            return (
                <div>
                    <p style={{textAlign: 'left'}}>1. 管理员拥有和创建者同等权限，帮助创建者管理店铺</p>
                    <p style={{textAlign: 'left', marginTop: '10px'}}>2. 客服：即本店铺课程咨询的消息接收者，为学员答疑解惑</p>
                </div>
            )
        };
        this.context.page.showAlert(text(),'','温馨提示');
    }

    handleSelfManage() {
        const {liveroomInfo, account} = this.props;
        axios.post(`/api/liveroom/${liveroomInfo.liveroom.id}/manager/${account.id}/change_liveroom_consulter`)
            .then(res => {
                if (res.data.code === 0){
                    this.context.page.showToast('设置客服成功');
                    axios.get(`/api/liveroom/${liveroomInfo.liveroom.id}/manager/list`)
                        .then(res => {
                            if (res.data.code === 0){
                                this.props.dispatch({
                                    type: 'LIVEROOM_MANAGE_INIT',
                                    payload: res.data.data
                                })
                            }
                        })
                }
            })
    }

    render() {
        const {liveroomInfo} = this.props;
        const {isConsulter} = this.state;
        return (
            <div className="manage-header" style={{backgroundImage: `url(${ManageBG})`}}>
                <div className="manage-header-question" onClick={this.handleTips}>
                    <img src={ManageHeaderImage} alt=""/>
                </div>
                <div className="manage-header-icon">
                    <img src={liveroomInfo.account.avatar_url} alt=""/>
                </div>
                <div className="manage-header-name">
                    {liveroomInfo.account.nickname}
                </div>
                <div className="manage-header-bespeaker" onClick={this.handleSelfManage}>
                    <img src={ManageSpeaker} alt=""/>
                    {isConsulter
                        ?
                        <span style={{opacity: '1'}}>客服</span>
                        :
                        <span>点击此处成为客服</span>
                    }
                </div>
            </div>
        )
    }
}

ManageHeader.contextTypes = {
    page: React.PropTypes.object,
};

export default connect(state => ({
    liveroomInfo:state.liveroomSetting.liveroomInfo,
    liveroomManage: state.liveroomSetting.liveroomManage,
    account: state.account
}))(ManageHeader)


// WEBPACK FOOTER //
// ./src/components/liveroomLecturer/ManageHeader.js